/**
 */
define(
    'constant/common/white-rightid-detail.constant',{
        "mgzLockScreenRightID": "8",//EMUI后面的杂志锁屏协议白名单。
        "createWebAppRightID": "10" ,//创建H5免安装应用白名单
        "automaticPublishInternal" : "11", //应用自动发布白名单（内部开发者）
    });
